import React, { useEffect, useState } from 'react'

const EditMemberFixedButton: React.FC = ({ children }) => {
    const [offset, setOffset] = useState(0)

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        const onScroll = () => setOffset(window.pageYOffset)
        // clean up code
        window.removeEventListener('scroll', onScroll)
        window.addEventListener('scroll', onScroll, { passive: true })
        return () => window.removeEventListener('scroll', onScroll)
    }, [])

    const mainContent = document.getElementById('main-content')
    const viewportHeight = window.innerHeight
    const mainContentOffset = mainContent?.offsetTop
    const mainContentHeight = mainContent?.clientHeight
    const buttonHidden =
        (mainContentOffset && offset < mainContentOffset) ?? true
    const buttonAbsoloute =
        offset + viewportHeight > mainContentOffset + mainContentHeight

    return (
        <div
            style={{
                position: buttonAbsoloute ? 'absolute' : 'fixed',
                display: 'block',
                top: buttonAbsoloute
                    ? mainContentOffset + mainContentHeight - 170
                    : 'calc(100dvh - 5rem)',
                left: '50%',
                transform: buttonHidden
                    ? 'translateX(calc(150%))'
                    : 'translateX(-50%)',
                transition: 'transform .3s ease-in-out',
                zIndex: 1,
            }}
        >
            {children}
        </div>
    )
}

export { EditMemberFixedButton }
